import ValidacaoService from "./ValidacaoService";
// Mixin padrão para a tabela
import TabelaMixin from "@/shared/mixin/TabelaMixin";

// Mixin com as services de unimeds
import UnimedService from "@/shared/services/UnimedService";

// Enum dos status
import { enumStatusValidacao, EnumPerfis } from "../../../shared/helpers/Enum";

export default {
  name: "validacao",
  mixins: [ValidacaoService, TabelaMixin, UnimedService],
  data() {
    return {
      limparUnimed: false,
      campoPesquisa: {
        descricao: "",
        chave: ""
      },
      listaStatus: [],
      listaUnimedOrigem: [
        {
          chave: 1,
          descricao: "Teste"
        }
      ],
      listaAnalistas: [],
      cabecalho: [
        {
          texto: "Data de envio",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "200px"
          },
          campoOrdenacao: "arquivo.dataGeracao"
        },
        {
          texto: "Data de recebimento",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "200px"
          },
          campoOrdenacao: "dtRecebimento"
        },
        {
          texto: "Número do protocolo",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "200px"
          },
          campoOrdenacao: "arquivo.cdTransacao"
        },
        {
          texto: "Nome do arquivo",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "150px"
          },
          campoOrdenacao: "arquivo.nome"
        },
        {
          texto: "Unimed origem",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "200px"
          },
          campoOrdenacao: "arquivo.unimed"
        },
        {
          texto: "Status",
          icone: "maximize-2",
          estiloColuna: {
            cursor: "pointer",
            "user-select": "none",
            "min-width": "150px"
          },
          campoOrdenacao: "status"
        }
      ]
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    /**
     * Método inicial da página
     */
    init() {
      this.loadingTabela = true;
      this.iniciarUnimedsFiltro().finally(() => {
        this.iniciarStatusFiltro().finally(() => {
          this.iniciarAnalistasResponsaveis().finally(() => {
            this.objetoTabela.ordenacao = "arquivo.dataGeracao";

            const { chave } = this.papelUsuarioMixin;
            if (chave === EnumPerfis.GTR) {
              this.$refs["filtro"].setFiltro({
                status: {
                  chave: "",
                  descricao: ""
                },
                unimedOrigem: {
                  chave: "",
                  descricao: ""
                },
                dataEnvioInicial: "",
                dataEnvioFinal: "",
                analistaResponsavel: {
                  chave: "",
                  descricao: this.nomeUsuarioMixin
                }
              });

              this.$nextTick(() => {
                this.$refs["filtro"].filtrar();
              });
            } else {
              this.iniciarTabela();
            }
          });
        });
      });
    },
    /**
     * Recupera todos os analistas
     */
    iniciarAnalistasResponsaveis() {
      return new Promise(resolve => {
        this.getAnalistasUnimed().then(res => {
          this.listaAnalistas = res.data;
          resolve();
        });
      });
    },
    /**
     * Método que faz a chamada na service para recuperar as unimeds utilizadas no filtro
     * @return { Promise<any> }
     */
    iniciarUnimedsFiltro() {
      return new Promise(resolve => {
        this.getAllUnimeds()
          .then(res => {
            this.listaUnimedOrigem = res.data;
          })
          .finally(() => {
            resolve();
          });
      });
    },
    /**
     * Método que faz a chamada na service para recuperar os status para o filtro
     * @return { Promise<any> }
     */
    iniciarStatusFiltro() {
      return new Promise(resolve => {
        this.getAllStatusValidacao()
          .then(res => {
            const lista = res.data;
            lista.forEach(e => {
              this.listaStatus.push({
                chave: e,
                descricao: enumStatusValidacao[e].textoExibicao
              });
            });
          })
          .finally(() => {
            resolve();
          });
      });
    },
    /**
     * Método que faz a chamada na service para recuperar as linhas da tabela e outras informações adicionais
     */
    iniciarTabela() {
      this.loadingTabela = true;
      let tempObjetoTabela = this.objetoTabelaAtual();

      if (this.campoPesquisa.chave) {
        tempObjetoTabela.unimedOrigem = this.campoPesquisa.chave;
      }

      this.getTabelaValidacoes(tempObjetoTabela)
        .then(res => {
          this.configurarTabela(res.data, rows => {
            this.montarTabela(rows);
          });
        })
        .finally(() => {
          this.loadingTabela = false;
          this.iniciado = true;
        });
    },
    /**
     * Método para montar a tabela
     *  @param {Array} rows - linhas da tabela
     */
    montarTabela(rows) {
      this.rows = [];
      rows.forEach(e => {
        const {
          dataEnvio,
          dataRecebimento,
          numeroProtocolo,
          nomeArquivo,
          unimedOrigem,
          status,
          id
        } = e;
        this.rows.push({
          dataEnvio: dataEnvio
            ? this.$helpers.formatadorHorario(dataEnvio)
            : " - ",
          dataRecebimento: dataRecebimento
            ? this.$helpers.formatadorHorario(dataRecebimento)
            : " - ",
          etiquetaTransacao: numeroProtocolo,
          nomeArquivo,
          unimedOrigem: {
            texto: unimedOrigem || " - ",
            qtdMaxCaracteres: 30,
            whiteSpaceNoWrap: false,
            larguraMaxima: 900,
            tooltipLocalizacao: "top"
          },
          status: enumStatusValidacao[status.chave],
          naoMostrar: {
            naoAparece: true,
            id
          }
        });
      });
      this.salvarFiltro();
    },
    /**
     * Método para selecionar o código da unimed
     * @param {Number, String} index - o index da listagem que está no autocomplete
     */
    selecionarPesquisa(index) {
      if ([undefined, null, "", -1].includes(index)) return;

      this.limparUnimed = true;
      this.$set(this.campoPesquisa, "chave", this.listaUnimedOrigem[index].id);
      this.filtrar({ unimedOrigem: "" });
    },
    /**
     * Limpa o objeto da pesquisa
     */
    limparPesquisa() {
      this.campoPesquisa = {
        descricao: "",
        chave: ""
      };
    },
    /**
     * Método pra fazer a chamada para unimedOrigem vazia, logo após limpar o campo de pesquisa
     */
    limparCampoPesquisa() {
      this.limparPesquisa();

      this.filtrar({ unimedOrigem: "" });
      this.limparUnimed = true;
    }
  }
};
